
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pos-payment-partners/payu",
      function () {
        return require("private-next-pages/pos-payment-partners/payu.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pos-payment-partners/payu"])
      });
    }
  